import ModelUpdate from "@/models/ModelUpdate";
import {IItemAdmin} from "@/models/item/ItemAdminModels";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class ItemUpdateReplacedBy extends ModelUpdate<IItemAdmin> {

	public replacedById!: string | null;

	public constructor(model: IItemAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IItemAdmin): void {
		this.replacedById = detailModel.replacedBy?.id ?? null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'replacedById':
			default:
				return [];
		}
	}

}
